"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "motion/react";
import Image from "next/image";
import { useEffect, useState } from "react";
type Testimonial = {
  name: string;
  company: string;
  location: string;
  quote: string;
  image: string;
};
const TESTIMONIALS: Testimonial[] = [{
  name: "Jennings Teller",
  company: "JBJ Lawn Mowers & Landscaping",
  location: "Havre du Grace, MD",
  quote: "We went from under $500k to pushing $1M in revenue thanks to Homeworks",
  image: "/next-assets/testimonial-jennings-teller.png"
}, {
  name: "Sam Gustin",
  company: "Troops Mowing",
  location: "Austin, TX",
  quote: "We've been able to reduce our office overhead by 60% thanks to the automations in Homeworks",
  image: "/next-assets/testimonial-sam-gustin.png"
}, {
  name: "Max Harwood",
  company: "Augusta Lawncare of Burnaby",
  location: "Burnaby, BC",
  quote: "We grew from $280k to $380k with a 20% profit margin thanks to efficiencies Homeworks helped me unlock",
  image: "/next-assets/testimonial-max-harwood.png"
}];
function pickRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)]!;
}
export function Testimonial() {
  const $ = _c(27);
  const [testimonial, setTestimonial] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setTestimonial(pickRandom(TESTIMONIALS));
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!testimonial) {
    return null;
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0
    };
    t3 = {
      opacity: 1
    };
    t4 = {
      duration: 0.5
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  const t5 = testimonial?.quote;
  let t6;
  if ($[5] !== t5) {
    t6 = <div className="flex text-lg font-semibold leading-snug tracking-wide">{t5}</div>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = testimonial?.name;
  let t8;
  if ($[7] !== t7) {
    t8 = <span className="text-lg leading-snug font-semibold">{t7}</span>;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span> | </span>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = testimonial?.location;
  let t11;
  if ($[10] !== t10) {
    t11 = <span>{t10}</span>;
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t11 || $[13] !== t8) {
    t12 = <div className="flex gap-2 text-base flex-wrap">{t8}{t9}{t11}</div>;
    $[12] = t11;
    $[13] = t8;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const t13 = testimonial?.company;
  let t14;
  if ($[15] !== t13) {
    t14 = <div className="flex text-base">{t13}</div>;
    $[15] = t13;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== t12 || $[18] !== t14) {
    t15 = <div className="">{t12}{t14}</div>;
    $[17] = t12;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== testimonial.image || $[21] !== testimonial.name) {
    t16 = <div className="absolute -bottom-12 left-1/2 -translate-x-1/2 rounded-full overflow-hidden aspect-square w-24"><Image src={testimonial.image} alt={testimonial.name} width={108} height={108} className="w-full h-full object-cover" /></div>;
    $[20] = testimonial.image;
    $[21] = testimonial.name;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t15 || $[24] !== t16 || $[25] !== t6) {
    t17 = <motion.div className="w-full max-w-[412px] mx-auto relative flex flex-col gap-4 rounded-2xl bg-brand-primary-100 text-brand-primary-950 p-6 pb-14" initial={t2} animate={t3} transition={t4}>{t6}{t15}{t16}</motion.div>;
    $[23] = t15;
    $[24] = t16;
    $[25] = t6;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  return t17;
}